/**
 * Položka historie posledních otevřených formulářů
 * @includeToDoc
 */
export interface IOpenedFormHistoryInfo {
    /** Kód formuláře */
    readonly formCode: string;
    /** Id položky menu, ze které byl otevřený */
    readonly menuItemId: number;
    /** Id profilu, který se má aplikovat */
    readonly profileId?: number;
}
